import React from 'react'
import PropTypes from 'prop-types'

import cx from 'classnames'
import { withTooltip } from '../tooltip/with-tooltip'
import { CardHeader } from './card-header'

import styles from './card-header-with-additional-data.module.css'
/**
 * A Card header component with additional information on the right of the header.
 * <code>
 *  <CardHeaderWithAdditionalData
 *  additionalHeaderText={formatIsoTime(2022-12-14T13:32:20Z)}
 *  additionalIcon={<AnyIcon />}
 *  tooltipContent='Last update'
 *  >
 *      Header with addtional informations
 *  </CardHeaderWithAdditionalData>
 * </code>
 * @param {object} props
 * @param {string} props.additionalHeaderText - Additional content
 * @param {string} [props.additionalIcon] - An optional Icon which is shown before the additional content
 * @param {string|ReactElement} [props.tooltipContent] - An optional parameter with content of the tooltip
 * @returns {ReactElement}
 */
export function CardHeaderWithAdditionalData({
    additionalClassName,
    additionalHeaderText,
    additionalIcon,
    children,
    className,
    tooltipContent
}) {
    const iconClass = cx({
        [styles['icon']]: !!additionalIcon,
        [styles['hide-icon']]: !additionalIcon
    })

    const AdditionalHeaderComponent = withTooltip(
        <div className={styles['additional-header-container']}>
            <span className={iconClass}>{additionalIcon}</span>
            <span className={cx(styles['additional-header-content'], additionalClassName)}>{additionalHeaderText}</span>
        </div>,
        tooltipContent
    )

    return (
        <CardHeader>
            <div className={cx(styles['card-header-content'], className)}>
                <span className={styles['card-header-label']}>{children}</span>
                <AdditionalHeaderComponent />
            </div>
        </CardHeader>
    )
}

CardHeaderWithAdditionalData.propTypes = {
    additionalHeaderText: PropTypes.string.isRequired,
    additionalIcon: PropTypes.element,
    additionalClassName: PropTypes.string,
    tooltipContent: PropTypes.element
}
